import { issueEnglishIqHandoffV1Api, recordWebVisitorV2Api } from '@repo/sdk';
import { buildWebFingerprint, getOrCreateVisitorId } from '@repo/web-chrome/lib/analytics';
import { requireEnglishIqResponseData } from '../../actions/require-english-iq-response-data';

export async function prepareEnglishIqV2OwnerHandoff(shareId: string): Promise<string> {
  const visitorId = getOrCreateVisitorId();
  const handoffResponse = await issueEnglishIqHandoffV1Api({ shareId, visitorId });
  const handoff = requireEnglishIqResponseData(handoffResponse.data.data);
  await recordWebVisitorV2Api({
    attributionPayload: null,
    fingerprint: buildWebFingerprint(),
    handoffToken: handoff.handoffToken,
    visitorId,
  });
  return handoff.handoffToken;
}
